/**
 * Legacy TenantApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.tenantApi`) keep resolving.
 *
 * The actual TenantApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/tenant/tenant-api.service.ts
 */
angular.module("acme.common.service.tenantApi", []);
